
//- Sliders


$(document).ready(function() {
  function gtm(action, event){
     var pourcentage = ((event.item.index + 1) / event.item.count) * 100 ;
     if (typeof variable !== 'undefined') {
        ga('send', {
          hitType: 'event',
          eventCategory: 'Browsing',
          eventAction: action,
          eventLabel: pourcentage
        });
     }
  }
  // Home News Slider
  function homeNewsSlider() {
    if(window.innerWidth < 993) {
      $('.home_news--inner').addClass('owl-carousel').addClass('owl-theme');
      $('.home_news--inner').owlCarousel({
        loop: false,
        items: 1,
        nav: true,
        dots: false,
        margin: 24,
        smartSpeed : 500
      }).on('changed.owl.carousel', function(event){
 
        gtm('news home page carousel scroll', event)
       });
    } else {
      $('.home_news--inner').removeClass('owl-carousel').removeClass('owl-theme');
      $('.home_news--inner').trigger('destroy.owl.carousel');
    }
  }
  // Home news slider init
  homeNewsSlider();
  window.addEventListener('resize', homeNewsSlider);



  // Home Chalets Slider
  $('.home_chalet--slider_inner').owlCarousel({
    loop: false,
    nav: true,
    margin: 16,
    smartSpeed : 500,
    responsive:{
      0: {
        items: 1,
        margin: 6
      },
      750: {
        items: 2
      },
      1032: {
        items: 3
      },
      1290: {
        items: 3
      }
    }
  }).on('changed.owl.carousel', function(event){
 
        gtm('Chalets home page carousel scroll', event)
       });

  
   // Home Activities Slider
  $('.home_activity--slider_inner').owlCarousel({
    loop: false,
    nav: true,
    margin: 18,
    smartSpeed : 500,
    responsive:{
      0: {
        items: 1,
        margin: 6
      },
      750: {
        items: 2
      },
      1032: {
        items: 3
      },
      1290: {
        items: 3
      }
    }
  }).on('changed.owl.carousel', function(event){
 
        gtm('Activities home page carousel scroll', event)
   });

  // Home Events Slider
  $('.about_activity--slider_inner').owlCarousel({
    loop: true,
    nav: false,
    margin: 18,
    smartSpeed : 500,
    responsive : {
      0: {
        items: 1,
        margin: 6
      },
      750: {
        items: 2
      },
      1032: {
        items: 3
      },
      1290: {
        items: 3
      }
    }
  }).on('changed.owl.carousel', function(event){
 
        gtm('Events home page carousel scroll', event)
       });

  // Home Promos Sliders
  $('#home--promos-slider .home_promos--slider-inner').owlCarousel({
    items: 1,
    loop: false,
    nav: true,
    dots: false,
    smartSpeed : 500,
    animateIn: 'fadeIn',
    onInitialized: initPrev,
    onTranslate: promosUpPre,
    onChanged : changeBackgroundPromos
  }).on('changed.owl.carousel', function(event){
 
        gtm('Promos home page carousel scroll', event)
  });

  
  // Home Promos Sliders
  $('#home--noah-slider .home_promos--slider-inner').owlCarousel({
    items: 1,
    loop: false,
    nav: true,
    dots: false,
    smartSpeed : 500,
    animateIn: 'fadeIn',
    onInitialized: initPrev,
    onTranslate: promosUpPre,
    onChanged : changeBackgroundNoah
  }).on('changed.owl.carousel', function(event){
 
        gtm('Promos home page carousel scroll', event)
  });


  function changeBackgroundPromos(e){
    setTimeout(function(){

    let back = $('#home--promos-slider .owl-item.active').find('.home_promos--item').attr('data-image');
    
    if( typeof(back) != 'undefined'){
      $('#home--promos-slider .home_promos--slider .home_promos--slider-previews').css('background-image', 'url('+back+')').addClass('test');
    }
    },100)
  }

  function changeBackgroundNoah(e){
    setTimeout(function(){

    let back = $('#home--noah-slider .owl-item.active').find('.home_promos--item').attr('data-image');
    
    if( typeof(back) != 'undefined'){
      $('#home--noah-slider .home_promos--slider .home_promos--slider-previews').css('background-image', 'url('+back+')').addClass('test');
    }
    },100)
  }

  function gCurrItem(e) {
    let container = e.target.querySelectorAll('.owl-item');
    let currIndex = e.item.index;
    let currItem = container[currIndex].querySelector('.home_promos--item');
    return currItem.getAttribute('data-prev');
  }
  function initPrev (e) {
    let currIPrev = gCurrItem(e);
    //console.log('init : ', currIPrev);
  }
  function promosUpPre(e) {
    let currIPrev = gCurrItem(e);
    //console.log('change : ', currIPrev);
  }


  //- Std Single Beds
  function stdSingleBeds() {
    if(window.innerWidth < 350) {
      $('.std_single--beds').addClass('owl-carousel').addClass('owl-theme');
      $('.std_single--beds').owlCarousel({
        loop: false,
        items: 1.5,
        nav: false,
        dots: false,
        margin: 16,
        smartSpeed : 500
      });
    } else {
      $('.std_single--beds').removeClass('owl-carousel').removeClass('owl-theme');
      $('.std_single--beds').trigger('destroy.owl.carousel');
    }
  }
  // Home news slider init
  stdSingleBeds();
  window.addEventListener('resize', stdSingleBeds);

  //- Std Single Activities
  function stdSingleActivities() {
    if(window.innerWidth < 350) {
      $('.std_single--activities-inner').addClass('owl-carousel').addClass('owl-theme');
      $('.std_single--activities-inner').owlCarousel({
        loop: false,
        items: 1.1,
        nav: false,
        dots: false,
        margin: 16,
        smartSpeed : 500
      }).on('changed.owl.carousel', function(event){
 
        gtm('Activities chalet page carousel scroll', event)
       });
    } else {
      $('.std_single--activities-inner').removeClass('owl-carousel').removeClass('owl-theme');
      $('.std_single--activities-inner').trigger('destroy.owl.carousel');
    }
  }
  // Home news slider init
  stdSingleActivities();
  window.addEventListener('resize', stdSingleActivities);

  //- Std Single Similar Chalet
  function stdSingleSimilar() {
    if(window.innerWidth < 350) {
      $('.std_single--similar-inner').addClass('owl-carousel').addClass('owl-theme');
      $('.std_single--similar-inner').owlCarousel({
        loop: false,
        items: 1.1,
        nav: false,
        dots: false,
        margin: 16,
        smartSpeed : 500
      }).on('changed.owl.carousel', function(event){
 
        gtm('Similar chalet, chalet page carousel scroll', event)
       });
    } else {
      $('.std_single--similar-inner').removeClass('owl-carousel').removeClass('owl-theme');
      $('.std_single--similar-inner').trigger('destroy.owl.carousel');
    }
  }
  // Home news slider init
  stdSingleSimilar();
  window.addEventListener('resize', stdSingleSimilar);
});